@if (visible) {
  @if (domains && domains.length>1) {
    <mat-form-field [ngClass]="cssClassName">
      @if (label?.length) {
        <mat-label>{{ label }}</mat-label>
      }
      <mat-select #select [value]="getSelectedValue()" (selectionChange)="onSelect($event.value)"
                  (openedChange)="onOpenedChange($event)"
                  [matTooltip]="getSelectionPathLabel()" matTooltipPosition="above">
        <mat-select-trigger>{{ currentDomain?.name || allLabel }}</mat-select-trigger>
        @if (needsHiddenSelection() && currentDomain) {
          <mat-option [value]="getSelectedValue()" style="display:none">{{ currentDomain.name }}</mat-option>
        }
        @for (domain of domains; track domain) {
          <mat-option [value]="''+domain.id"
                      [class.top-level-indent]="!viewDomain && domain.id !== 0 && !domain.isChild">
            @if (domain.isParent) {
              <a href="javascript:void(0)" class="drill-up" [title]="drillUpTitle"
                 (mousedown)="$event.stopPropagation()"
                 (click)="drillUp($event)">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </a>
            } @else if (domain.id !== 0 && (viewDomain || domain.isChild)) {
              <mat-icon>{{ getIconName(domain) }}</mat-icon>
            }
            <span class="domain-name">{{ domain.name }}</span>
            @if (hasChildren(domain)) {
              <a href="javascript:void(0)" class="drill-in" [title]="drillInTitle"
                 (mousedown)="$event.stopPropagation()"
                 (click)="drillInto(domain, $event)">
                <mat-icon>{{ isExpanded(domain) ? 'expand_more' : 'chevron_right' }}</mat-icon>
              </a>
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
}
